import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/imgs/basic/user_avatar.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "user-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, "JiangBei")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 退出系统 ")

import router from '@/router';
import { removeToken } from '@/utils/auth';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const logout = () => {
  removeToken();
  router.push('/login');
};

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, { trigger: "click" }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, { class: "logout" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, { onClick: logout }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})